// Feilreferanser (PRD 1.0 US22), delt av appen og edge-funksjonene: en
// referanse som vises til brukeren og lagres i error_log, og rensing av
// feilteksten før den lagres.

// Uten 0/O og 1/I/L, så referansen er lett å lese opp.
const REF_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";

export const newErrorRef = () => {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  return `F-${[...bytes].map((b) => REF_ALPHABET[b % REF_ALPHABET.length]).join("")}`;
};

const REF_IN_TEXT = /\(Referanse: (F-[A-Z0-9]{6})\)/;

export const refFromMessage = (message: string | undefined | null) =>
  message?.match(REF_IN_TEXT)?.[1] ?? null;

export const withRefText = (message: string, ref: string) =>
  refFromMessage(message) ? message : `${message} (Referanse: ${ref})`;

/**
 * Fjerner det som ikke skal i loggen: tokens og nøkler, e-postadresser,
 * verdier Postgres siterer i feilmeldinger, og alt utover 300 tegn.
 */
export const sanitizeErrorMessage = (message: unknown) =>
  String(message ?? "")
    .replace(/Bearer\s+[\w.~+/=-]+/gi, "Bearer [fjernet]")
    .replace(/eyJ[\w-]+\.[\w-]+\.[\w-]+/g, "[token]")
    .replace(/\b(sb_[a-z]+_|sk-|key-)[\w-]{8,}/gi, "[nøkkel]")
    .replace(/\b[a-f0-9]{32,}\b/gi, "[nøkkel]")
    .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, "[e-post]")
    .replace(/=\([^)]*\)/g, "=(…)")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 300);
